import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Pane, AccordionSet, Accordion, MenuSection, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekSelection, RecekTextField } from "../../components/inputs";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { useOnixCodetableItemsFilters } from "../../hooks/useOnixCodetableItemsFilters";
import { useOnixCodetableItemsData } from "../../hooks/useOnixCodetableItemsData";
import { useOnixCodetableItemsTable } from "../../hooks/useOnixCodetableItemsTable";
import { usePageSize } from "../../hooks/usePageSize";
var OnixCodetablesItemsList = function () {
    var history = useHistory();
    var location = useLocation();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var filtersHook = useOnixCodetableItemsFilters();
    var _b = usePageSize(), pageSize = _b.pageSize, createPageSizeHandler = _b.createPageSizeHandler;
    var dataHook = useOnixCodetableItemsData(filtersHook.selectedOnix, filtersHook.filters, pageSize);
    var columns = useOnixCodetableItemsTable().columns;
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleApplyFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var source = createStripesSource({
        ky: null,
        data: dataHook.items,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading,
        isError: dataHook.isError,
        isLoaded: dataHook.isFetched,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.navigation.pane.title",
            }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                React.createElement(AccordionSet, null,
                    React.createElement("form", { onSubmit: function (e) {
                            e.preventDefault();
                            handleApplyFilters();
                        } },
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-agency.onixCodetablesItemsList.accordion.label.filterByName",
                            }), separator: false },
                            React.createElement(RecekSelection, { labelId: "ui-br-agency.onixCodetablesItemsList.accordion.label.filterByName", showLabel: false, name: "onixSelection", value: filtersHook.selectedOnix, onChange: filtersHook.handleOnixSelection, asyncFilter: true, loading: filtersHook.onixLoading, onFilter: filtersHook.handleOnixInput, dataOptions: filtersHook.onixDataOptions })),
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-agency.onix-codetable-items.form.section.value",
                            }), separator: false },
                            React.createElement(RecekTextField, { labelId: "ui-br-agency.onix-codetable-items.filter.value.label", showLabel: false, value: filtersHook.temporaryValueFilter, onChange: function (e) {
                                    return filtersHook.setTemporaryValueFilter(e.target.value);
                                }, placeholder: formatMessage({
                                    id: "ui-br-agency.onix-codetable-items.filter.placeholder.value",
                                }), marginBottom0: true, fullWidth: true })),
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-agency.onix-codetable-items.form.section.description",
                            }), separator: false },
                            React.createElement(RecekTextField, { labelId: "ui-br-agency.onix-codetable-items.filter.description.label", showLabel: false, value: filtersHook.temporaryDescriptionFilter, onChange: function (e) {
                                    return filtersHook.setTemporaryDescriptionFilter(e.target.value);
                                }, placeholder: formatMessage({
                                    id: "ui-br-agency.onix-codetable-items.filter.placeholder.description",
                                }), marginBottom0: true, fullWidth: true })),
                        React.createElement(Button, { type: "submit", marginBottom0: true }, formatMessage({ id: "ui-br-agency.button.apply" }))))))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.onix-codetables-items.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }), actionMenu: function (_a) {
                var onToggle = _a.onToggle;
                return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            onToggle();
                            var params = new URLSearchParams(location.search);
                            var onixCodetableId = params.get("onixCodetableId");
                            var url = "/bragency/onix-codetable-items/create";
                            history.push(onixCodetableId
                                ? "".concat(url, "?onixCodetableId=").concat(onixCodetableId)
                                : url);
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
            } },
            React.createElement(TableComponent, { data: dataHook.items, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source }))));
};
export default OnixCodetablesItemsList;
